import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.scss';
import { QueryProvider } from './providers/QueryProvider';
import ToastProvider from './shared/components/CustomToast/ToastProvider.tsx';
import { initChunkLoadRecovery } from './shared/utils/chunkLoadRecovery';
import { initSentry } from './services/sentry';

initChunkLoadRecovery();
initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ToastProvider position="top-left">
      <QueryProvider>
        <App />
      </QueryProvider>
    </ToastProvider>
  </StrictMode>
);
